import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRegCalendar } from 'react-icons/fa6';
import { DoctorAppointment } from 'src/types/doctor-appointment.types';
import Card from '../../kit/card/Card';
import StatefulCard from '../../kit/card/StatefulCard';
import StatelessCard from '../../kit/card/StatelessCard';
import Text from '../../kit/text/Text';
import Button from '../../kit/button/Button';
import { formatDate } from 'src/app/utils/date-time.utils';
import { AppRoutes } from 'src/types/app-routes.enum';

type DoctorAppointmentCardProps = {
  scheduledAppointment?: DoctorAppointment;
};

const DoctorAppointmentCard = ({
  scheduledAppointment,
}: DoctorAppointmentCardProps) => {
  const navigate = useNavigate();
  const appointmentDate: string | undefined = useMemo(
    () =>
      scheduledAppointment?.appointmentDate
        ? formatDate(scheduledAppointment.appointmentDate, true)
        : undefined,
    [scheduledAppointment]
  );
  const onClick = () => navigate(AppRoutes.DoctorAppointment);

  return (
    <>
      {scheduledAppointment ? (
        <Card
          title='Doctor visit'
          editText='Edit'
          isEditable
          onEdit={onClick}
          onCardClick={onClick}
        >
          <StatefulCard
            action='Upcoming visit'
            imageSource='images/doctor-visit.svg'
            name={scheduledAppointment?.doctorType ?? ''}
            notification={
              <Text
                style={{
                  fontSize: '14px',
                  color: 'var(--color-text-gray)',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <FaRegCalendar />
                &nbsp;&nbsp;{appointmentDate}
              </Text>
            }
          />
        </Card>
      ) : (
        <Card title='Doctor visit' onCardClick={onClick}>
          <StatelessCard
            text='Add reminder for your upcoming appointment'
            imageSource='images/add-doctor-appointment.svg'
            imageType='bg-image'
            imageStyles={{ height: '119px', width: '109px' }}
            Button={
              <Button
                type='transparent'
                width='content-width'
                style={{ fontWeight: 500, padding: 0, height: 'fit-content' }}
                onClick={onClick}
              >
                +&nbsp;&nbsp;Add visit
              </Button>
            }
          />
        </Card>
      )}
    </>
  );
};

export default DoctorAppointmentCard;
